<template>
	<div class="central content flex flex-align-start">
		<div class="flex-1 mr40">
			<div class="mt20 pointer" v-for="item in dataList" @click="toArticle(item)">
				<div>
					<span class="f16" style="color: #606266;">{{item.title}}</span>
					<span class="float-r" style="color: #999999;">{{item.createDatetime}}</span>
				</div>
				<div class="bor-bottom mt10" style="border-color: #DCDFE6;"></div>
			</div>
			<!-- 分页 -->
			<div class="mt20 flex flex-pack-justify" v-if="dataList.length">
				<div></div>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="pageSizeArr" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
			</div>
		</div>
		
		<!-- 宣传图 -->
		<el-carousel class="border-radius-10" style="width: 360px;" trigger="click" :interval="5000" arrow="never" height="480px">
			<el-carousel-item v-for="(item,index) in swiper" :key="index">
				<el-image style="width: 360px;height: 480px;" :src="item.image" fit="cover"></el-image>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'
export default {
	name: 'Targeted',
	data(){
		return{
			loading: false,  // 搜索按钮loading
			dataList: [],
			page: 1,
			page_size: 10,
		}
	},
	mounted(){
		EventBus.$emit('router-path', this.$route.path)

		if(this.token) this.getUser()

		this.getData()
	},
	methods: {
		toArticle(item){
			this.$router.push('/friendContent?id=' + item.id)
		},
		async getData(){
			this.isLoading = true
			let params = {
				pageNum: this.page,
				pageSize: this.page_size
			}
			this.$http.get('/api/webs/search/moment', { params })
			.then(response => {
				let res = response.data
				this.isLoading = false
				if(res!=null){
					this.totalCount = res.total
					this.dataList = res.list
				}
			})
			.catch(error => {
				console.error(error)
				this.isLoading = false
			})
		},
		handleSizeChange(val) {
			this.page_size = val
			this.isLoading = true
			this.getData()
		},
		handleCurrentChange(val) {
			this.page = val
			this.isLoading = true
			this.getData()
		},
	}
}
</script>

<style scoped>

</style>